export const subscriptionPlanSubDescription: Record<string, string> = {
  "1_month": "Auto-renews each month until cancelled",
  "6_month": "Auto-renews every 6 months until cancelled",
  "1_year": "Auto-renews each year until cancelled",
};
